<span class="value"
  >{{ value }}
  <span class="text-unit">{{ unit }}</span>
</span>
